import React, { useEffect } from 'react';
declare global {
  interface Window {
    jotformEmbedHandler?: (selector: string, origin: string) => void;
  }
}
const JOTFORM_ID = '262298095114056';
const JOTFORM_SRC = `https://form.jotform.com/${JOTFORM_ID}`;
const HANDLER_SRC = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
interface ConsultationFormProps {
  formId: string;
  heading: string;
}
export function ConsultationForm({
  formId,
  heading
}: ConsultationFormProps) {
  const iframeId = `JotFormIFrame-${JOTFORM_ID}-${formId}`;
  useEffect(() => {
    const selector = `iframe[id='${iframeId}']`;
    const attachHandler = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(selector, 'https://form.jotform.com/');
      }
    };
    if (window.jotformEmbedHandler) {
      attachHandler();
      return;
    }
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${HANDLER_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', attachHandler);
      return () => existing.removeEventListener('load', attachHandler);
    }
    const script = document.createElement('script');
    script.src = HANDLER_SRC;
    script.async = true;
    script.addEventListener('load', attachHandler);
    document.body.appendChild(script);
    return () => script.removeEventListener('load', attachHandler);
  }, [iframeId]);
  return <div className="w-full rounded-2xl bg-white p-6 shadow-xl sm:p-8" data-id="element-54" data-mp="21x334gtexwfj">
      <h3 className="font-display mb-6 text-xl font-bold text-[var(--color-navy)] sm:text-2xl" data-id="element-55" data-mp="21uqke1ftzi1f">
        {heading}
      </h3>
      <div className="-mx-5" data-id="element-56" data-mp="1swey2blzz6es">
        <iframe id={iframeId} title={heading} src={JOTFORM_SRC} allow="geolocation; microphone; camera; fullscreen; payment" scrolling="no" className="block w-full" style={{
        minWidth: '100%',
        maxWidth: '100%',
        height: '539px',
        border: 'none'
      }} data-id="element-57" data-mp="1sv3lbmakqobj" />
      </div>
    </div>;
}